// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"329":"2b23fe56","347":"baa810e9","354":"1d69175d","505":"4ee59476","549":"de642627","680":"4fbe6887","742":"3cb5a77b","823":"01b14945"}[chunkId] + ".chunk.js";
};